import imgSrc from '../javascripts/imgSrc'
let ja = {
  postureHome: {
    indexPage: {
      a_posture_title: '姿勢レポート',
      show: '1'
    },
    coverInfo: {
      customerName: 'テスト対象',
      date: 'テスト日付',
      time: 'テスト時間',
      userName: 'テストアナリスト',
      clickEnterReport: 'レポートを観覧するにはクリック'
    }
  },

  postureIpad: {
    bullet: {
      Home: 'ホーム',
      Posturedata: '姿勢データ',
      Score: 'リスク分析',
      Muscle: '筋肉分析',
      Solution: '解決法'
    },
    front: '正面',
    side: '側面',
    viwesNav: '側面 | 正面',
    InvalidData: '無効なレポート',
    qrcode: 'エクササイズをアンロックするためには弊社にメールにて問い合わせください。',
    expertsWalk: 'Senno Posture',
    smallProgram: 'support@sennotech.com',
    clickRightTop: '右上のボタンをクリックしてください。',
    clickTranspond: 'ミニプログラムをシェアするにはクリックしてください。',
    symptoms: {
      head: [
        {
          name: '頭の傾き',
          key: 'headSidesway',
          normal: {
            left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [
            {
              name: '慢性的な筋肉および靭帯の緊張',
              des:
                '長時間の頭部傾斜または斜頸は、後頸部靭帯および周囲の筋肉の慢性的な緊張につながる可能性があります。'
            },
            {
              name: '頸椎症',
              des:
                '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
            }
          ]
        },
        {
          name: 'ストレートネック',
          key: 'headLean',
          normal: {
            normal: imgSrc.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [
            {
              name: 'めまいと頭痛',
              des:
                '頭が前に出た姿勢から生じる循環不良が原因の脳低酸素症は、めまいや頭痛を引き起こす可能性があります。'
            },
            {
              name: '頸椎症',
              des:
                '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
            }
          ]
        }
      ],
      shoulder: [
        {
          name: '肩の高さ違い',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [
            {
              name: '慢性頭痛',
              des:
                '肩が不均一になると、最終的には慢性的な頭痛につながる可能性があります。'
            },
            {
              name: '骨棘',
              des:
                '肩が水平でないと、頸部に異常な力が発生し、頸椎や場合によっては骨棘が変性しやすくなります。 '
            },
            {
              name: '腰痛',
              des:
                '肩の傾斜は、骨盤の外側への傾き、腰の筋肉の不均衡、腰痛を引き起こす可能性があります。'
            },
            {
              name: '脚長不一致',
              des: '骨盤の側面の傾きは脚長不一致のリスクを高めます。'
            }
          ]
        },
        {
          name: '猫背',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [
            {
              name: '循環器疾患',
              des: ' 猫背は横隔膜を緊張させ、心血管疾患のリスクを高めます。'
            },
            {
              name: '頭痛',
              des:
                '猫背の原因となる首と肩の緊張は、頸部神経の圧迫や頭痛を引き起こすことさえあります。'
            },
            {
              name: '腕のしびれ',
              des:
                '頸部神経の圧迫は、腕のしびれや感覚異常を引き起こすこともあります。'
            }
          ]
        }
      ],
      trunk: [
        {
          name: '脊椎側彎症',
          key: 'spineSidesway',
          normal: {
            left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [
            {
              name: '脊椎側彎症',
              des: '脊椎側彎症の診断には、さらに3D検査が必要です。'
            },
            {
              name: '肩の高さ違い',
              des: '脊椎側彎症には肩の高さ違いが伴う場合があります。'
            },
            {
              name: '腰の高さ違い',
              des: '脊椎側彎症には、腰の高さ違いが伴う場合があります。'
            }
          ]
        }
      ],
      pelvis: [
        {
          name: '腰の高さ違い',
          key: 'pelvisLean',
          normal: {
            left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [
            {
              name: '慢性的な痛み',
              des: '不均一な腰は四肢の痛みを引き起こす可能性があります。'
            },
            {
              name: '腰椎椎間板ヘルニア',
              des:
                '腰の高さ違いは、腰椎椎間板ヘルニアになるリスクを高める可能性があります。'
            },
            {
              name: '脚の長さ違い',
              des:
                '腰の高さ違いは、脚長不一致のリスクを高める可能性があります。'
            }
          ]
        }
      ],
      'lower extremity': [
        {
          name: 'O脚',
          key: 'legO',
          normal: {
            normal: imgSrc.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [
            {
              name: '半月板損傷',
              des: 'O脚の人の下肢にかかる力は普通とは違いがあり '
            },
            {
              name: '関節炎',
              des:
                '重度のO脚は、最終的に関節の外側間質腔の変形性関節症に進行する可能性があります。'
            }
          ]
        },
        {
          name: '内反脚（ノックニー）',
          key: 'legX',
          normal: {
            normal: imgSrc.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [
            {
              name: '半月板損傷',
              des:
                'X脚は下肢にかかる力の方向が変わるため、膝の側圧が増加します。外側半月板の緊張と損傷がしばしば起こります。'
            },
            {
              name: '関節炎',
              des:
                '重度の内反脚は最終的に変形性関節症に進行する可能性があります。'
            }
          ]
        },
        {
          name: '反張膝',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [
            {
              name: '変性膝関節疾患',
              des: '持続的な反張膝は過度な膝摩耗と変性の原因になります。'
            },
            {
              name: 'ボディバランスへの影響',
              des:
                '変形した膝は、腰、骨盤、足首の位置の変化につながり、徐々に全身のバランスに影響してきます。'
            }
          ]
        },
        {
          name: 'XO脚',
          key: 'legXO',
          normal: {
            normal: imgSrc.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [
            {
              name: '膝の痛み',
              des:
                '骨盤が前方に傾くと、膝関節にも「グリッド」のずれが生じます。大腿骨が脛骨（脛骨）を適切に追従しないため、不均衡が生じます。不均衡と、骨盤前傾が原因で弱くなった大臀筋の影響で内転した大腿骨が組み合わさると、XO脚（膝下からO脚）になる条件が揃います。\n' +
                '動き回ると頻繁に膝が鳴ることもあるでしょう。'
            },
            {
              name: '関節炎',
              des:
                '時間の経過とともに、膝の安定化構造（軟骨や靭帯など）がニュートラルポジションの膝に比べてはるかに速い速度ですり減るので、痛みを感じるようになります。'
            }
          ]
        }
      ]
    }
  },

  postureModalIpad: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: 'ハイリスク',
    suggest:
      '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。',
    suggestSolve:
      '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: 'ノーマル',
    risk: 'リスク',
    return: 'リターン',
    levelName: '高 | 中 | 低'
  },

  postureModal: {
    normal: 'ノーマル',
    highRisk: 'ハイリスク',
    goback: '戻る',
    potentialRisk: '中リスク',
    levelName: '高 | 中 | 低',
    symptominterpretation: 'アドバイス',
    triggersymptoms: 'インパクト'
  },

  postureReport: {
    redAlert: 'レッドゾーンは筋肉の緊張を表します',
    yellowAlert: '黄色のゾーンは筋力低下を意味します',
    muscleDire: {
      normal: 'ノーマル',
      face: '正面',
      side: '側面',
      back: '背面'
    },
    details: {
      lh: 'lh',
      ll: 'll',
      rh: 'rh',
      rr: 'rr'
    },
    descripName: {
      upName: 'を強化する必要があります',
      lowName: 'をストレッチする必要があります'
    },
    navList: '正面 |側面 | 背面',
    boneDescription: {
      face: {
        trunk: '腹筋',
        legForX: ['股関節外転筋', '股関節内転筋'],
        legForO: '股関節外転筋',
        legForStretch: '大腿四頭筋',
        round: '大胸筋'
      },
      side: {
        round: '胸鎖乳突筋',
        fore: '胸鎖乳突筋',
        shoulder: '斜角筋'
      },
      back: {
        spine: '上部僧帽筋',
        shoulder: '上部僧帽筋',
        round: ['上部僧帽筋', '下部僧帽筋'],
        fore: ['上部僧帽筋', '下部僧帽筋'],
        rake: '肩甲骨',
        legStretch: ['大腿部膝屈筋', '足底筋膜'],
        legX: ['股関節外転筋', '大腿二頭筋'],
        legO: ['大腿部膝屈筋', 'Invetors'],
        legXO: ['大腿二頭筋', '足底筋膜']
      }
    }
  },

  postureSymp: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: 'ハイリスク',
    suggest:
      '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。 ',
    suggestSolve:
      '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: '普通',
    risk: 'リスク'
  },

  postureSympIpad: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: 'ハイリスク',
    suggest:
      '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。 ',
    suggestSolve:
      '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: '普通',
    risk: 'リスク'
  },

  posture: {
    bullet: {
      Home: 'ホーム',
      Posturedata: '姿勢データ',
      Score: 'リスク分析',
      Muscle: '筋肉分析',
      Solution: '解決法'
    },
    front: '正面',
    side: '側面',
    viwesNav: '側面 | 正面',
    InvalidData: '無効なレポート',
    qrcode: 'エクササイズをアンロックするためには弊社にメールにて問い合わせください。',
    expertsWalk: 'Senno Posture',
    smallProgram: 'support@sennotech.com',
    clickRightTop: '右上のボタンをクリックしてください。',
    clickTranspond: 'ミニプログラムをシェアするにはクリックしてください。',
    symptoms: {
      head: [
        {
          name: '頭の傾き',
          key: 'headSidesway',
          normal: {
            left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [
            {
              name: '慢性的な筋肉および靭帯の緊張',
              des:
                '長時間の頭部傾斜または斜頸は、後頸部靭帯および周囲の筋肉の慢性的な緊張につながる可能性があります。'
            },
            {
              name: '頸椎症',
              des:
                '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
            }
          ]
        },
        {
          name: 'ストレートネック',
          key: 'headLean',
          normal: {
            normal: imgSrc.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [
            {
              name: 'めまいと頭痛',
              des:
                '頭が前に出た姿勢から生じる循環不良が原因の脳低酸素症は、めまいや頭痛を引き起こす可能性があります。'
            },
            {
              name: '頸椎症',
              des:
                '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
            }
          ]
        }
      ],
      shoulder: [
        {
          name: '肩の高さ違い',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [
            {
              name: '慢性頭痛',
              des:
                '肩が不均一になると、最終的には慢性的な頭痛につながる可能性があります。'
            },
            {
              name: '骨棘',
              des:
                '肩が水平でないと、頸部に異常な力が発生し、頸椎や場合によっては骨棘が変性しやすくなります。 '
            },
            {
              name: '腰痛',
              des:
                '肩の傾斜は、骨盤の外側への傾き、腰の筋肉の不均衡、腰痛を引き起こす可能性があります。'
            },
            {
              name: '脚長不一致',
              des: '骨盤の側面の傾きは脚長不一致のリスクを高めます。'
            }
          ]
        },
        {
          name: '猫背',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [
            {
              name: '循環器疾患',
              des: ' 猫背は横隔膜を緊張させ、心血管疾患のリスクを高めます。'
            },
            {
              name: '頭痛',
              des:
                '猫背の原因となる首と肩の緊張は、頸部神経の圧迫や頭痛を引き起こすことさえあります。'
            },
            {
              name: '腕のしびれ',
              des:
                '頸部神経の圧迫は、腕のしびれや感覚異常を引き起こすこともあります。'
            }
          ]
        }
      ],
      trunk: [
        {
          name: '脊椎側彎症',
          key: 'spineSidesway',
          normal: {
            left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [
            {
              name: '脊椎側彎症',
              des: '脊椎側彎症の診断には、さらに3D検査が必要です。'
            },
            {
              name: '肩の高さ違い',
              des: '脊椎側彎症には肩の高さ違いが伴う場合があります。'
            },
            {
              name: '腰の高さ違い',
              des: '脊椎側彎症には、腰の高さ違いが伴う場合があります。'
            }
          ]
        }
      ],
      pelvis: [
        {
          name: '腰の高さ違い',
          key: 'pelvisLean',
          normal: {
            left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [
            {
              name: '慢性的な痛み',
              des: '不均一な腰は四肢の痛みを引き起こす可能性があります。'
            },
            {
              name: '腰椎椎間板ヘルニア',
              des:
                '腰の高さ違いは、腰椎椎間板ヘルニアになるリスクを高める可能性があります。'
            },
            {
              name: '脚の長さ違い',
              des:
                '腰の高さ違いは、脚長不一致のリスクを高める可能性があります。'
            }
          ]
        }
      ],
      'lower extremity': [
        {
          name: 'O脚',
          key: 'legO',
          normal: {
            normal: imgSrc.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [
            {
              name: '半月板損傷',
              des: 'O脚の人の下肢にかかる力は普通とは違いがあり '
            },
            {
              name: '関節炎',
              des:
                '重度のO脚は、最終的に関節の外側間質腔の変形性関節症に進行する可能性があります。'
            }
          ]
        },
        {
          name: '内反脚（ノックニー）',
          key: 'legX',
          normal: {
            normal: imgSrc.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [
            {
              name: '半月板損傷',
              des:
                'X脚は下肢にかかる力の方向が変わるため、膝の側圧が増加します。外側半月板の緊張と損傷がしばしば起こります。'
            },
            {
              name: '関節炎',
              des:
                '重度の内反脚は最終的に変形性関節症に進行する可能性があります。'
            }
          ]
        },
        {
          name: '反張膝',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [
            {
              name: '変性膝関節疾患',
              des: '持続的な反張膝は過度な膝摩耗と変性の原因になります。'
            },
            {
              name: 'ボディバランスへの影響',
              des:
                '変形した膝は、腰、骨盤、足首の位置の変化につながり、徐々に全身のバランスに影響してきます。'
            }
          ]
        },
        {
          name: 'XO脚',
          key: 'legXO',
          normal: {
            normal: imgSrc.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [
            {
              name: '膝の痛み',
              des:
                '骨盤が前方に傾くと、膝関節にも「グリッド」のずれが生じます。大腿骨が脛骨（脛骨）を適切に追従しないため、不均衡が生じます。不均衡と、骨盤前傾が原因で弱くなった大臀筋の影響で内転した大腿骨が組み合わさると、XO脚（膝下からO脚）になる条件が揃います。\n' +
                '動き回ると頻繁に膝が鳴ることもあるでしょう。'
            },
            {
              name: '関節炎',
              des:
                '時間の経過とともに、膝の安定化構造（軟骨や靭帯など）がニュートラルポジションの膝に比べてはるかに速い速度ですり減るので、痛みを感じるようになります。'
            }
          ]
        }
      ]
    }
  },

  sympItem: {
    levelName: '高 | 中 | 低'
  },

  sympItemIpad: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: '高リスク',
    suggest:
      '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。',
    suggestSolve:
      '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: '普通',
    risk: 'リスク',
    levelName: '高 | 中 | 低'
  }
}
export { ja }



// WEBPACK FOOTER //
// ./src/assets/lang.conf/ja.js